// Basic
const color = 'color';
const fontFamily = 'font-family';
const backgroundColor = 'background-color';
// Typography
const text = `text ${color} ${fontFamily}`;
const textDanger = `text-danger ${text}`;
const heading = `heading ${text}`;
const heading1 = `heading-1 ${heading}`;
const heading2 = `heading-2 ${heading}`;
const heading3 = `heading-3 ${heading}`;
const heading4 = `heading-4 ${heading}`;
const heading5 = `heading-5 ${heading}`;
// Button
const button = `button ${text}`;
const buttonPrimary = `button-primary ${button}`;
const buttonSecondary = `button-secondary ${button}`;
const buttonLink = `button-link ${button}`;
const buttonLoading = `button-loading`;
const buttonDisabled = `button-disabled ${button}`;
// Input
const label = `label ${text}`;
const input = `input ${text} ${backgroundColor}`;
const inputGroup = `input-group ${input}`;
const inputInvalid = `input-invalid ${input}`;
const inputDisabled = `input-disabled ${input}`;
const inputFocused = `input-focused ${input}`;
const inputInvalidAndFocused = `input-invalid-and-focused ${input}`;
const inputRadio = `input-radio`;
const inputRadioFocused = `input-radio-focused ${inputRadio}`;
const inputRadioChecked = `input-radio-checked ${inputRadio}`;
const inputRadioCheckedFocused = `input-radio-checked-focused ${inputRadio}`;
const inputRadioInvalid = `input-radio-invalid ${inputRadio}`;
const inputCheckbox = `input-checkbox`;
const inputCheckboxInvalid = `input-checkbox-invalid ${inputCheckbox}`;
const inputCheckboxFocused = `input-checkbox-focused ${inputCheckbox}`;
const inputCheckboxChecked = `input-checkbox-checked ${inputCheckbox}`;
const inputCheckboxCheckedFocused = `input-checkbox-checked-focused ${inputCheckbox}`;
const inputAdornment = `input-adornment ${text}`;
// Alert
const alert = `alert ${text}`;
const alertDanger = `alert-danger ${alert}`;
// Tooltip
const tooltip = `tooltip ${text}`;
const tooltipIcon = `tooltip-icon ${text}`;
const tooltipInner = `tooltip-inner ${text}`;
// Card
const card = `card ${text} ${backgroundColor}`;
// Table
const table = `table ${text} ${backgroundColor}`;
const tableCell = `table-cell ${text} ${backgroundColor}`;
const tableHeadCell = `table-head-cell ${tableCell} ${text} ${backgroundColor}`;
const tableCellEven = `table-cell-even ${tableCell} ${text} ${backgroundColor}`;
const tableCellOdd = `table-cell-odd ${tableCell} ${text} ${backgroundColor}`;
const getAlternateTableCellPart = (index) => index % 2 ? tableCellEven : tableCellOdd;
const tableEmpty = `table-empty ${text} ${backgroundColor}`;
const tableError = `table-error ${text} ${backgroundColor}`;
// Loading spinner
const loadingSpinner = `loading-spinner`;
// Badge
const badge = `badge ${fontFamily}`;
const badgePrimary = `${badge} badge-primary`;
const badgeSecondary = `${badge} badge-secondary`;
const badgeSuccess = `${badge} badge-success`;
const badgeDanger = `${badge} badge-danger`;
const badgeWarning = `${badge} badge-warning`;
const badgeInfo = `${badge} badge-info`;
const badgeLight = `${badge} badge-light`;
const badgeDark = `${badge} badge-dark`;
// Dropdown-menu
const dropdownMenu = `dropdown-menu ${text}`;
// Radio List Item
const radioListItem = `radio-list-item ${text}`;
// Skeleton
const skeleton = `skeleton`;
// Image
const image = `image`;
// Component specific
// This allows specific sections of a component to be hidden, for example
// ::part(billing-form) { display: none; }
const billingForm = `billing-form`;
const checkoutSummary = `checkout-summary`;
// Filters
const filterMenu = `filter-menu`;
// Payments List Filters
const paymentsListFilterMenu = `${filterMenu} payments-list-filter-menu`;
const paymentsListFilterParam = `payments-list-filter-param`;
const paymentIdPaymentsListFilterParam = `${paymentsListFilterParam} payment-id-payments-list-filter-param`;
const terminalIdPaymentsListFilterParam = `${paymentsListFilterParam} terminal-id-payments-list-filter-param`;
const paymentStatusPaymentsListFilterParam = `${paymentsListFilterParam} payment-status-payments-list-filter-param`;
const createdAfterPaymentsListFilterParam = `${paymentsListFilterParam} created-after-payments-list-filter-param`;
const createdBeforePaymentsListFilterParam = `${paymentsListFilterParam} created-before-payments-list-filter-param`;
// Payouts List Filters
const payoutsListFilterMenu = `${filterMenu} payouts-list-filter-menu`;
const payoutsListFilterParam = `payouts-list-filter-param`;
const createdAfterPayoutsListFilterParam = `${payoutsListFilterParam} created-after-payouts-list-filter-param`;
const createdBeforePayoutsListFilterParam = `${payoutsListFilterParam} created-before-payouts-list-filter-param`;
// Checkouts List Filters
const checkoutsListFilterMenu = `${filterMenu} checkouts-list-filter-menu`;
const checkoutsListFilterParam = `checkouts-list-filter-param`;
const statusCheckoutsListFilterParam = `${checkoutsListFilterParam} checkout-status-checkouts-list-filter-param`;
const paymentModeCheckoutsListFilterParam = `${checkoutsListFilterParam} payment-mode-checkouts-list-filter-param`;
// Terminals List Filters
const terminalsListFilterMenu = `${filterMenu} terminals-list-filter-menu`;
const terminalsListFilterParam = `terminals-list-filter-param`;
const terminalIdTerminalsListFilterParam = `${terminalsListFilterParam} terminal-id-terminals-list-filter-param`;
const terminalOrderIdTerminalsListFilterParam = `${terminalsListFilterParam} terminal-order-id-terminals-list-filter-param`;
const terminalStatusTerminalsListFilterParam = `${terminalsListFilterParam} terminal-status-terminals-list-filter-param`;
// Terminal Orders List Filters
const terminalOrdersListFilterMenu = `${filterMenu} terminal-orders-list-filter-menu`;
const terminalOrdersListFilterParam = `terminal-orders-list-filter-param`;
const orderStatusTerminalOrdersListFilterParam = `${terminalOrdersListFilterParam} order-status-terminal-orders-list-filter-param`;
const orderTypeTerminalOrdersListFilterParam = `${terminalOrdersListFilterParam} order-type-terminal-orders-list-filter-param`;
const createdAfterTerminalOrdersListFilterParam = `${terminalOrdersListFilterParam} created-after-terminal-orders-list-filter-param`;
const createdBeforeTerminalOrdersListFilterParam = `${terminalOrdersListFilterParam} created-before-terminal-orders-list-filter-param`;

export { statusCheckoutsListFilterParam as $, badgeSecondary as A, badgePrimary as B, badge as C, alertDanger as D, inputCheckboxInvalid as E, inputCheckboxCheckedFocused as F, inputCheckboxFocused as G, inputCheckboxChecked as H, inputCheckbox as I, inputAdornment as J, inputGroup as K, inputRadioInvalid as L, inputRadioCheckedFocused as M, inputRadioChecked as N, inputRadioFocused as O, inputRadio as P, inputInvalidAndFocused as Q, heading3 as R, checkoutSummary as S, radioListItem as T, heading4 as U, image as V, heading5 as W, buttonSecondary as X, buttonPrimary as Y, buttonLoading as Z, checkoutsListFilterMenu as _, heading1 as a, paymentModeCheckoutsListFilterParam as a0, dropdownMenu as a1, getAlternateTableCellPart as a2, paymentsListFilterMenu as a3, paymentIdPaymentsListFilterParam as a4, terminalIdPaymentsListFilterParam as a5, paymentStatusPaymentsListFilterParam as a6, createdAfterPaymentsListFilterParam as a7, createdBeforePaymentsListFilterParam as a8, payoutsListFilterMenu as a9, createdAfterPayoutsListFilterParam as aa, createdBeforePayoutsListFilterParam as ab, terminalOrdersListFilterMenu as ac, orderStatusTerminalOrdersListFilterParam as ad, orderTypeTerminalOrdersListFilterParam as ae, createdAfterTerminalOrdersListFilterParam as af, createdBeforeTerminalOrdersListFilterParam as ag, terminalsListFilterMenu as ah, terminalIdTerminalsListFilterParam as ai, terminalOrderIdTerminalsListFilterParam as aj, terminalStatusTerminalsListFilterParam as ak, billingForm as al, tableEmpty as am, tableError as an, inputInvalid as b, inputDisabled as c, inputFocused as d, tooltipIcon as e, tooltip as f, tooltipInner as g, heading2 as h, input as i, textDanger as j, card as k, label as l, table as m, tableHeadCell as n, tableCell as o, buttonLink as p, buttonDisabled as q, loadingSpinner as r, skeleton as s, text as t, badgeDark as u, badgeLight as v, badgeInfo as w, badgeWarning as x, badgeDanger as y, badgeSuccess as z };
